<div class="spinner" [ngStyle]="spinnerStyle$ | async">
  <mat-spinner color="primary" [diameter]="20" mode="indeterminate"></mat-spinner>
</div>
